(() => {

  /* =========================================================
     LONICERA — DELIVERY SYSTEM
     ========================================================= */

  const SURCHARGE_VARIANT_ID = 55401068265801;
  const SURCHARGE_VARIANT_ID_STRING = String(SURCHARGE_VARIANT_ID);

  const SLOT_09 = '09h00 – 12h00';
  const SLOT_12 = '12h00 – 15h00';
  const SLOT_15 = '15h00 – 18h00';

  /* =========================================================
   VACATION / CLOSED DELIVERY DATES
   ========================================================= */

const VACATION_START = '2026-10-08';
const VACATION_END   = '2026-10-20';

function isVacationDate(value) {
  return (
    value >= VACATION_START &&
    value <= VACATION_END
  );
}

  /* =========================================================
     SWISS DATE / TIME
     ========================================================= */

  function getSwissNow() {

    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());

    const values = {};

    parts.forEach((part) => {
      if (part.type !== 'literal') {
        values[part.type] = Number(part.value);
      }
    });

    return {
      year: values.year,
      month: values.month,
      day: values.day,
      hour: values.hour,
      minute: values.minute
    };
  }


  function pad(value) {
    return String(value).padStart(2, '0');
  }


  function dateToString(date) {
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate())
    );
  }


  function addDays(date, days) {

    const result = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    result.setDate(result.getDate() + days);

    return result;
  }


  function parseDate(value) {

    if (!value) return null;

    const parts = value.split('-').map(Number);

    return new Date(
      parts[0],
      parts[1] - 1,
      parts[2]
    );
  }


  function isSunday(value) {

    const date = parseDate(value);

    return date
      ? date.getDay() === 0
      : false;
  }


  /* =========================================================
     DELIVERY RULES

     STANDARD

     Until 15:00
       Tomorrow from 09:00

     15:01 → 17:00
       Tomorrow from 12:00

     17:01 → 18:00
       Tomorrow from 15:00

     After 18:00
       Tomorrow NOT available
       Day after tomorrow from 09:00


     URGENT

     Until 18:00
       Tomorrow from 09:00

     After 18:00
       Tomorrow ONLY:
       12:00–15:00
       15:00–18:00

     ========================================================= */


  function getRules(urgentChecked) {

    const swiss = getSwissNow();

    const today = new Date(
      swiss.year,
      swiss.month - 1,
      swiss.day
    );

    const minutesNow =
      (swiss.hour * 60) + swiss.minute;

    const cutoff15 = 15 * 60;
    const cutoff17 = 17 * 60;
    const cutoff18 = 18 * 60;

    let minimumDays = 1;
    let firstSlotHour = 9;


    /* URGENT */

    if (urgentChecked) {

      minimumDays = 1;

      if (minutesNow > cutoff18) {
        firstSlotHour = 12;
      } else {
        firstSlotHour = 9;
      }

    }


    /* STANDARD */

    else {

      if (minutesNow <= cutoff15) {

        minimumDays = 1;
        firstSlotHour = 9;

      }

      else if (minutesNow <= cutoff17) {

        minimumDays = 1;
        firstSlotHour = 12;

      }

      else if (minutesNow <= cutoff18) {

        minimumDays = 1;
        firstSlotHour = 15;

      }

      else {

        minimumDays = 2;
        firstSlotHour = 9;

      }

    }


    const minimumDate =
      addDays(today, minimumDays);


    return {

      swiss,

      minimumDate,

      minimumDateString:
        dateToString(minimumDate),

      firstSlotHour,

      urgent:
        urgentChecked,

      after18:
        minutesNow > cutoff18

    };
  }


  /* =========================================================
     CART API
     ========================================================= */

  async function getCart() {

    const response =
      await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

    if (!response.ok) {
      throw new Error(
        'Impossible de lire le panier.'
      );
    }

    return response.json();
  }

async function saveUrgentAttribute(isUrgent) {

  const response = await fetch(
    window.Shopify.routes.root + 'cart/update.js',
    {
      method: 'POST',
      credentials: 'same-origin',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        attributes: {
          'Livraison urgente': isUrgent ? 'Oui' : ''
        }
      })
    }
  );

  if (!response.ok) {
    throw new Error(
      'Impossible d’enregistrer le choix de livraison urgente.'
    );
  }

  return response.json();
}
async function saveDeliveryDate(deliveryDate) {

  const response = await fetch(
    window.Shopify.routes.root + 'cart/update.js',
    {
      method: 'POST',
      credentials: 'same-origin',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        attributes: {
          'Date de livraison souhaitée': deliveryDate
        }
      })
    }
  );

  if (!response.ok) {
    throw new Error(
      'Impossible d’enregistrer la date de livraison.'
    );
  }

  return response.json();
}

  async function addSurcharge() {

  const response = await fetch(
    window.Shopify.routes.root + 'cart/add.js',
    {
      method: 'POST',

      credentials: 'same-origin',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        items: [
          {
            id: SURCHARGE_VARIANT_ID,
            quantity: 1
          }
        ]
      })
    }
  );

  if (!response.ok) {
    throw new Error(
      'Impossible d’ajouter le supplément de livraison.'
    );
  }

  return response.json();
}


  async function removeSurcharge(items) {

    const updates = {};

    items.forEach((item) => {
      updates[item.key] = 0;
    });


    await fetch('/cart/update.js', {

      method: 'POST',

      credentials: 'same-origin',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        updates
      })

    });
  }


  function refreshCartUI() {

    document.dispatchEvent(
      new CustomEvent(
        'cart:update',
        {
          bubbles: true
        }
      )
    );
  }


  /* =========================================================
     INITIALIZE DELIVERY FORM
     ========================================================= */

  function initLoniceraDelivery() {

    const containers =
      document.querySelectorAll(
        '.lonicera-delivery'
      );


    containers.forEach((container) => {

      if (
        container.dataset.initialized ===
        'true'
      ) {
        return;
      }


      container.dataset.initialized =
        'true';


      const date =
        container.querySelector(
          '#LoniceraDeliveryDate'
        );

      const time =
        container.querySelector(
          '#LoniceraDeliveryTime'
        );

      const phone =
        container.querySelector(
          '#LoniceraRecipientPhone'
        );

      const urgent =
        container.querySelector(
          '#LoniceraUrgent'
        );

      const availabilityMessage =
        container.querySelector(
          '#LoniceraAvailabilityMessage'
        );

      const surchargeMessage =
        container.querySelector(
          '#LoniceraSurchargeMessage'
        );


      if (
        !date ||
        !time ||
        !phone ||
        !urgent
      ) {
        return;
      }


      /* =====================================================
         DATE RULE
         ===================================================== */

      function updateDate() {

        const rules =
          getRules(urgent.checked);


        date.min =
          rules.minimumDateString;


        /*
         Remove an old date that is no
         longer allowed.
        */

        if (
          date.value &&
          date.value <
            rules.minimumDateString
        ) {

          date.value = '';

          time.value = '';

        }
/* Vacation closure */

if (
  date.value &&
  isVacationDate(date.value)
) {
  date.value = '';
  time.value = '';

  date.setCustomValidity(
    'Lonicera est en vacances du 8 au 20 octobre. Les livraisons reprennent dès le 21 octobre.'
  );

  date.reportValidity();
} else {
  date.setCustomValidity('');
}
      }


      /* =====================================================
         TIME SLOT RULE
         ===================================================== */

      function updateSlots() {

        const rules =
          getRules(urgent.checked);

        const selectedDate =
          date.value;


        /*
         Only the earliest delivery date
         has restricted time slots.

         Future dates get all slots.
        */

        const earliestDate =
          selectedDate ===
          rules.minimumDateString;


        Array
          .from(time.options)
          .forEach((option) => {

            /*
             Keep placeholder.
            */

            if (
              !option.dataset.startHour
            ) {

              option.disabled = false;

              option.hidden = false;

              option.style.display = '';

              return;
            }


            const hour =
              Number(
                option.dataset.startHour
              );


            let available = true;


            if (earliestDate) {

              available =
                hour >=
                rules.firstSlotHour;

            }


            option.disabled =
              !available;

            option.hidden =
              !available;

            option.style.display =
              available
                ? ''
                : 'none';

          });


        /*
         If customer previously selected
         a slot that is now forbidden,
         clear it.
        */

        const selectedOption =
          time.options[
            time.selectedIndex
          ];


        if (
          selectedOption &&
          selectedOption.dataset
            .startHour &&
          selectedOption.disabled
        ) {

          time.value = '';

        }


        updateAvailabilityMessage();

      }


      /* =====================================================
         MESSAGE BELOW TIME FIELD
         ===================================================== */

      function updateAvailabilityMessage() {

        if (
          !availabilityMessage
        ) {
          return;
        }


        const rules =
          getRules(urgent.checked);


        if (!date.value) {

          if (
            !urgent.checked &&
            rules.after18
          ) {

            availabilityMessage
              .textContent =
              'Après 18h00, la livraison standard est disponible à partir du surlendemain. Pour une livraison demain après-midi, sélectionnez « Livraison urgente ».';

          }

          else {

            availabilityMessage
              .textContent =
              'Les créneaux disponibles sont adaptés automatiquement selon l’heure de votre commande.';

          }

          return;
        }


        const earliestDate =
          date.value ===
          rules.minimumDateString;


        if (!earliestDate) {

          availabilityMessage
            .textContent =
            'Tous les créneaux sont disponibles pour cette date.';

          return;
        }


        /*
         URGENT AFTER 18:00
        */

        if (
          urgent.checked &&
          rules.after18
        ) {

          availabilityMessage
            .textContent =
            'Livraison urgente demain : créneaux disponibles de 12h00 à 15h00 et de 15h00 à 18h00.';

          return;
        }


        /*
         STANDARD
        */

        if (
          rules.firstSlotHour === 9
        ) {

          availabilityMessage
            .textContent =
            'Tous les créneaux sont disponibles pour cette date.';

        }

        else if (
          rules.firstSlotHour === 12
        ) {

          availabilityMessage
            .textContent =
            'Pour cette date, la première livraison disponible est de 12h00 à 15h00.';

        }

        else if (
          rules.firstSlotHour === 15
        ) {

          availabilityMessage
            .textContent =
            'Pour cette date, seul le créneau de 15h00 à 18h00 est disponible.';

        }

      }


      /* =====================================================
         SURCHARGE MESSAGE
         ===================================================== */

      function updateSurchargeMessage() {

        if (
          !surchargeMessage
        ) {
          return;
        }


        const sunday =
          isSunday(date.value);


        if (
          sunday &&
          urgent.checked
        ) {

          surchargeMessage.hidden =
            false;

          surchargeMessage
            .textContent =
            'Supplément de CHF 15.– appliqué pour la livraison urgente / dimanche.';

        }

        else if (sunday) {

          surchargeMessage.hidden =
            false;

          surchargeMessage
            .textContent =
            'Livraison le dimanche : supplément de CHF 15.– appliqué automatiquement.';

        }

        else if (
          urgent.checked
        ) {

          surchargeMessage.hidden =
            false;

          surchargeMessage
            .textContent =
            'Livraison urgente : supplément de CHF 15.– appliqué.';

        }

        else {

          surchargeMessage.hidden =
            true;

          surchargeMessage
            .textContent = '';

        }

      }


      /* =====================================================
         SYNCHRONIZE CHF 15 SURCHARGE
         ===================================================== */

      async function syncSurcharge() {

        const shouldHaveSurcharge =
          urgent.checked ||
          isSunday(date.value);


        try {

          const cart =
            await getCart();


          const surchargeItems =
            cart.items.filter(
              (item) =>
                String(
                  item.variant_id
                ) ===
                SURCHARGE_VARIANT_ID_STRING
            );


          /*
    /*
 * Add surcharge
 */

if (
  shouldHaveSurcharge &&
  surchargeItems.length === 0
) {

  await addSurcharge();

  window.location.reload();
  return;

}


/*
 * Remove surcharge
 */

else if (
  !shouldHaveSurcharge &&
  surchargeItems.length > 0
) {

  await removeSurcharge(surchargeItems);

  window.location.reload();
  return;

}

} catch (error) {

  console.error(
    'Lonicera surcharge:',
    error
  );

}

}


      /* =====================================================
         VALIDATION
         ===================================================== */

      function validateField(
        field,
        errorId
      ) {

        if (!field) return true;


        const error =
          container.querySelector(
            '#' + errorId
          );


        const valid =
          field.value.trim() !== '';


        if (error) {

          error.hidden =
            valid;

        }


        field.setAttribute(
          'aria-invalid',
          valid
            ? 'false'
            : 'true'
        );


        return valid;

      }


      function validateRules() {

        const rules =
          getRules(
            urgent.checked
          );


        /*
         Date required
        */

        if (!date.value) {
          return false;
        }


        /*
         Date cannot be before
         minimum allowed date.
        */

        if (
          date.value <
          rules.minimumDateString
        ) {
          return false;
        }
/* Vacation dates are not allowed */

if (isVacationDate(date.value)) {
  return false;
}

        /*
         Time required
        */

        if (!time.value) {
          return false;
        }


        const selected =
          time.options[
            time.selectedIndex
          ];


        if (!selected) {
          return false;
        }


        /*
         Explicitly validate the slot
         again instead of trusting
         disabled/hidden OPTION.
        */

        if (
          date.value ===
          rules.minimumDateString
        ) {

          const hour =
            Number(
              selected.dataset
                .startHour
            );


          if (
            !hour ||
            hour <
              rules.firstSlotHour
          ) {

            return false;

          }

        }


        return true;

      }


      function validateAll() {

        const dateOK =
          validateField(
            date,
            'LoniceraDateError'
          );


        const timeOK =
          validateField(
            time,
            'LoniceraTimeError'
          );


        const phoneOK =
          validateField(
            phone,
            'LoniceraPhoneError'
          );


        const rulesOK =
          validateRules();


        const valid =
          dateOK &&
          timeOK &&
          phoneOK &&
          rulesOK;


        if (!valid) {

          if (!rulesOK) {

            updateDate();

            updateSlots();

          }


          const firstInvalid =
            container.querySelector(
              '[aria-invalid="true"]'
            );


          if (firstInvalid) {

            firstInvalid.focus();

            firstInvalid
              .scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });

          }

        }


        return valid;

      }


      /* =====================================================
         EVENTS
         ===================================================== */

      date.addEventListener(
        'change',
        async () => {

          updateDate();

          updateSlots();

          updateSurchargeMessage();


          validateField(
  date,
  'LoniceraDateError'
);

await saveDeliveryDate(
  date.value
);

await syncSurcharge();

}
);


      time.addEventListener(
        'change',
        () => {

          validateField(
            time,
            'LoniceraTimeError'
          );

        }
      );


      phone.addEventListener(
        'input',
        () => {

          validateField(
            phone,
            'LoniceraPhoneError'
          );

        }
      );


      urgent.addEventListener(
        'change',
        async () => {

          /*
           Important:
           changing urgent status changes
           the minimum date AND available
           time slots.
          */

          updateDate();

          updateSlots();

          updateSurchargeMessage();

await saveUrgentAttribute(
  urgent.checked
);

          await syncSurcharge();

        }
      );


      /* =====================================================
         INITIAL STATE
         ===================================================== */

      updateDate();

      updateSlots();

      updateSurchargeMessage();


      /*
       Expose validator on this container
       for checkout validation.
      */

      container.loniceraValidate =
        validateAll;

    });


    /* =======================================================
       CHECKOUT PROTECTION
       ======================================================= */

    if (
      !window
        .LoniceraCheckoutValidationInstalled
    ) {

      window
        .LoniceraCheckoutValidationInstalled =
        true;


      document.addEventListener(
        'click',
        function(event) {

          const checkout =
            event.target.closest(
              '#checkout, button[name="checkout"], .cart__checkout-button'
            );


          if (!checkout) {
            return;
          }


          const container =
            checkout
              .closest(
                'cart-drawer, .cart-drawer, form, section'
              )
              ?.querySelector(
                '.lonicera-delivery'
              )
            ||
            document.querySelector(
              '.lonicera-delivery'
            );


          if (!container) {
            return;
          }


          if (
            typeof container
              .loniceraValidate ===
            'function'
          ) {

            const valid =
              container
                .loniceraValidate();


            if (!valid) {

              event.preventDefault();

              event.stopPropagation();

              event
                .stopImmediatePropagation();

            }

          }

        },

        true
      );

    }

  }


  /* =========================================================
     BOOT / HORIZON CART REDRAW
     ========================================================= */

  function bootLonicera() {

    initLoniceraDelivery();


    /*
     Horizon redraws the cart drawer
     dynamically.

     Watch for newly created cart
     elements and initialize them.
    */

    if (
      !window
        .LoniceraCartObserverInstalled
    ) {

      window
        .LoniceraCartObserverInstalled =
        true;


      const observer =
        new MutationObserver(() => {

          initLoniceraDelivery();

        });


      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      bootLonicera
    );

  }

  else {

    bootLonicera();

  }

})();

